import { UseQueryResult, useQuery } from "@tanstack/react-query";
import NotificationsListResponse from "../../../models/API/responseModels/notificationsListResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import NotificationsListService from "../../../NotificationsListService";
import ApiNotificationData from "../../../models/notificationsModels/apiNotificationsData.model";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";

function TransformResponse(res: any, dispatch: any) {
 let response = JSON.parse(res);

 const NotificationsList = new NotificationsListService(response.data);
 const unReadCount = response.data.filter(
  (notification: ApiNotificationData) => notification.isRead == false
 ).length;
 dispatch({ type: "SET_NOTIFICATION_COUNT", payload: unReadCount });

 response = {
  ...response,
  data: NotificationsList.getNotificationsList(),
 };
 return response;
}

function useNotificationsList({
 params,
}: {
 params: string;
}): UseQueryResult<NotificationsListResponse, any> {
 const { authState } = useOktaAuth();
 const { dispatch } = useContext(ApplicationState);

 return useQuery({
  queryKey: ["notifications", { params }],
  queryFn: ({ queryKey }) => {
   const [_key, { params }]: any = queryKey;

   return axiosInstance
    .get(`/v1/notifications/${params}`, {
     headers: {
      Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
     },
     transformResponse: (res: any) => TransformResponse(res, dispatch),
    })
    .then((res) => {
     return res.data;
    });
  },
 });
}

export default useNotificationsList;
